/**
 * Pending promise which can be resolved/rejected on demand.
 */
class AsapPromise {
  constructor() {
    this.#promise = new Promise((resolve, reject) => {
      this.#resolve = resolve;
      this.#reject = reject;
    });
  }

  resolve(arg) {
    this.#resolve(arg);
  }
  reject(arg) {
    this.#reject(arg);
  }

  then(...args) {
    return this.#promise.then(...args);
  }
  catch(...args) {
    return this.#promise.catch(...args);
  }
  finally(...args) {
    return this.#promise.finally(...args);
  }

  #promise;
  #resolve;
  #reject;
}

export { AsapPromise };
